import t from 'utils/translationHelper';
import * as yup from 'yup';

import { PaymentOnlineOrigin } from '@alpha/payments-dtos';

import { FormikPaymentType } from '../../../../Payments/CreatePaymentDrawer/formData';

export const initialValues: FormikPaymentType = {
  emailAddresses: [],
  paymentOrigin: PaymentOnlineOrigin.DRAWDOWN,
  date: null,
};

export const validation = {
  beneficiary: yup
    .object({
      id: yup.string().required(),
    })
    .required(t('please_enter_a_beneficiary_amount')),
  amount: yup.number().typeError(t('please_enter_numbers_only'))
    .required(t('please_select_an_amount'))
    .positive(t('please_enter_an_amount_greater_than_zero')),
  date: yup.string().required(t('please_specify_a_payment_date')),
  reference: yup.string().nullable()
  .matches(/^[A-Za-z0-9.,?/:()+‘’' -]*$/, t('special_characters_are_not_allowed'))
  .test('len', t('must_be_140_characters_or_less'), (val) => {
    if (!val) return true;
    return val?.length <= 140;
  }),
  purposeType: yup.string().oneOf(['Service', 'Unspecified']).nullable(),
  purpose: yup.string().max(200, t('purpose_must_be_200_characters_or_less')),
  emailAddresses: yup.array().of(yup.string().email(t('invalid_email_address'))),
  invoiceNumber: yup.string().when('purposeType', {
    is: 'Service',
    then: yup.string().required(t('invoice_number_is_a_required_field'))
      .matches(/^[A-Za-z0-9.,?/:()+‘’' -]*$/, t('special_characters_are_not_allowed')),
  }).nullable(),
  invoiceDate: yup.string().when('purposeType', {
    is: 'Service',
    then: yup.string().required(t('invoice_date_required_for_purpose_code_service')),
  }).nullable(),
};

export default validation;
